<template>
  <hsp-layout>
    <template v-slot:sidebar>
      <side-bar
        :background-color="sidebarBackground"
        short-title="HSP"
        title="HSP">
        <template slot="links">
          <sidebar-item
            :link="{
              name: 'Survey Users',
              icon: 'tim-icons icon-badge',
              path: { name: linkName, params: linkParams }
            }">
          </sidebar-item>
          <sidebar-item
            :link="{
              name: 'Add Survey User',
              icon: 'tim-icons icon-simple-add',
              path: { name: addLinkName, params: linkParams }
            }">
          </sidebar-item>
        </template>
      </side-bar>
    </template>
  </hsp-layout>
</template>
<script>
  import HspLayout from './HspLayout';

  export default {
    data() {
      return {
        modes: { default: 1, surveyId: 2, surveyUrlId: 3 },
        sidebarBackground: 'primary' //vue|blue|orange|green|red|primary,
      };
    },
    components: {
      HspLayout
    },
    computed: {
      mode() {
        return this.$route.params.surveyId && this.$route.params.surveyUrlId ? this.modes.surveyUrlId 
          : this.$route.params.surveyId ? this.modes.surveyId
          : this.modes.default;
      },
      linkName() {
        return this.mode === this.modes.surveyId ? "HspSurveyUsers"
          : this.mode === this.modes.surveyUrlId ? "InstanceSurveyUsers"
          : "SurveyUsers";
      },
      addLinkName() {
        return this.mode === this.modes.surveyId ? "AddHspSurveyUser"
          : this.mode === this.modes.surveyUrlId ? "AddInstanceSurveyUser"
          : "AddSurveyUser";
      },
      linkParams() {
        return this.mode === this.modes.surveyId ? { surveyId: this.$route.params.surveyId }
          : this.mode === this.modes.surveyUrlId ? { surveyUrlId: this.$route.params.surveyUrlId }
          : {};
      },
    },
  }
</script>
